module.exports = __webpack_public_path__ + "Flag-352.f82662d448460559d653dc1415448a1a.svg";